import { createContext, useContext, useEffect, useRef } from 'react';

/**
 * Sekce stránky pro mobilní lištu.
 *
 * Do jednoho místa se sešly dvě věci, které se dřív hlásily zvlášť: název sekce
 * pro horní hlavičku a seznam sekcí pro Palec vpravo dole (jako prop). Byly to
 * tytéž údaje, jen dvakrát — stránka musela vědět o obou plochách. Obě ty
 * plochy mezitím zanikly a jejich práci převzal střed spodní lišty; tenhle
 * kontext je jediné místo, kam se sekce hlásí.
 *
 * Stránka teď řekne, co má, a je jí jedno, kdo to kreslí:
 *
 *     useSekce({
 *         sekce: [{ id: 'suroviny', label: 'Suroviny', Icon: Package }, …],
 *         aktivni: tab,
 *         onVyber: prepnout,
 *     });
 *
 * Stránka bez sekcí nevolá nic a lišta ukáže jen název modulu.
 */
export const SekceContext = createContext(() => {});

/**
 * Pošle liště sekce stránky. `null` (nebo nic) = stránka sekce nemá.
 *
 * Pole `sekce` bývá počítané při každém renderu, takže identita se mění pořád;
 * hlídá se proto jeho obsah, ne reference — jinak by se stav lišty přepisoval
 * po každém překreslení stránky.
 */
export function useSekce(data) {
    const nastav = useContext(SekceContext);
    const posledni = useRef(null);

    const sekce = data?.sekce ?? null;
    const aktivni = data?.aktivni ?? null;
    const onVyber = data?.onVyber ?? null;
    const otisk = sekce ? sekce.map(s => `${s.id}:${s.label}`).join('|') : '';

    useEffect(() => {
        // `onVyber` se mění při každém renderu (bývá to inline funkce), ale
        // nesmí kvůli tomu běžet efekt — drží se v ref a čte se při volbě.
        posledni.current = onVyber;
        nastav(sekce && sekce.length
            ? { sekce, aktivni, onVyber: (id) => posledni.current?.(id) }
            : null);
        return () => nastav(null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nastav, otisk, aktivni]);

    posledni.current = onVyber;
}
